// src/components/Client/NewClientModal.jsx
import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import NewClientForm from "./NewClientForm";

class NewClientModal extends Component {
  state = {
    modal: false,
  };

  toggle = () => {
    this.setState((prev) => ({
      modal: !prev.modal,
    }));
  };

  render() {
    const { create, client } = this.props;
    const title = create ? "Nuevo Cliente" : "Editar Cliente";

    return (
      <>
        {create ? (
          <Button color="success" onClick={this.toggle}>
            Nuevo Cliente
          </Button>
        ) : (
          <Button color="warning" size="sm" onClick={this.toggle}>
            Editar
          </Button>
        )}

        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>{title}</ModalHeader>
          <ModalBody>
            <NewClientForm
              // 🔑 pass the full client AND pk explicitly
              client={client}
              pk={client?.id}
              create={create}
              resetState={this.props.resetState}
              toggle={this.toggle}
            />
          </ModalBody>
        </Modal>
      </>
    );
  }
}

export default NewClientModal;
